module.exports = __webpack_public_path__ + "static/media/FORMATO CERTIFICADO DE ACUMULACION DE DECIMOS.5f8fbda1.pdf";